import {
  updateLabelConfig,
  labelConfigSelector,
  onLabelPropertyValueChange,
} from '../../../../data/labelInfos/index.js'
import ConfigSelect from '../ConfigSelect.js'
import {getState, useSelector} from '../../../../store.js'
import {DHL} from '../../../../common/constants/ShipperNames.js'
import ConfigTextInput from '../ConfigTextInput.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from '../useLabelProperty.js'

const LABEL_PROPERTY_INTERNAL_TRANSACTION_NUMBER = 'internal_transaction_number'

const VALID_SHIPPER_TYPES = [DHL]

function foreignTradeRegulationTemplate(shipperType) {
  return `${shipperType}__foreign_trade_regulation`
}
const FOREIGN_TRADE_REGULATION_VALID_LABEL_PROPERTIES = VALID_SHIPPER_TYPES.map(
  (shipperType) => foreignTradeRegulationTemplate(shipperType),
)

function foreignTradeRegulationLabelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [foreignTradeRegulationTemplate(shipperType)]
    : []
}

const INTERNAL_TRANSACTION_NUMBER_VALID_LABEL_PROPERTIES = [
  LABEL_PROPERTY_INTERNAL_TRANSACTION_NUMBER,
]

function internalTransactionNumberLabelPropertiesFunc(
  shipperType,
  labelInfoID,
) {
  const foreignTradeRegulation = labelConfigSelector(getState(), {labelInfoID})[
    foreignTradeRegulationLabelPropertiesFunc(shipperType)
  ]

  return !foreignTradeRegulation
    ? [LABEL_PROPERTY_INTERNAL_TRANSACTION_NUMBER]
    : []
}

export function ForeignTradeRegulation() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = ForeignTradeRegulation.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigSelect
      label="Foreign Trade Regulation"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onLabelPropertyValueChange(labelInfoID, labelProperty)

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="foreign_trade_regulation"
    />
  )
}

ForeignTradeRegulation.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: foreignTradeRegulationLabelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc() {
      return FOREIGN_TRADE_REGULATION_VALID_LABEL_PROPERTIES
    },
  },
]

export function ForeignTradeRegulationNotice() {
  const {shipperType, isSummary, isPickMode} = useLabelConfigContext()
  const [foreignTradePropertySpecs] = ForeignTradeRegulation.propertySpecList

  if (
    !foreignTradePropertySpecs.validShipperTypes.includes(shipperType) ||
    isSummary ||
    isPickMode
  ) {
    return null
  }

  return (
    <li className="list__item--shipping-options wrap--edit-preset-modal-hide-item margin-bottom-5">
      <a
        className="btn btn--link fs-n1"
        href="https://mydhl.express.dhl/hn/en/shipment/foreign-trade-regulation.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn more about FTR
      </a>
    </li>
  )
}

export function InternalTransactionNumber() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [foreignTradePropertySpecs] = ForeignTradeRegulation.propertySpecList
  const [internalTransactionNumberPropertySpecs] =
    InternalTransactionNumber.propertySpecList
  const [foreignTradeLabelProperty] =
    foreignTradePropertySpecs.labelPropertiesFunc(shipperType, labelInfoID)
  const [internalTransactionNumberLabelProperty] =
    internalTransactionNumberPropertySpecs.labelPropertiesFunc(
      shipperType,
      labelInfoID,
    )

  const foreignTradeRegulation = useSelector(
    (state) =>
      labelConfigSelector(state, {labelInfoID})[foreignTradeLabelProperty] ||
      '',
  )

  return (
    <ConfigTextInput
      label="Internal Transaction Number"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [internalTransactionNumberLabelProperty]: value,
        })

        onChange()
      }}
      labelProperty={internalTransactionNumberLabelProperty}
      propertySpecs={internalTransactionNumberPropertySpecs}
      hide={foreignTradeRegulation !== ''}
    />
  )
}

InternalTransactionNumber.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: internalTransactionNumberLabelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc() {
      return INTERNAL_TRANSACTION_NUMBER_VALID_LABEL_PROPERTIES
    },
  },
]
